import {
  getAll,
  searchByName,
  getPage,
  getDetail,
  addObj,
  modifyObj,
  deleteObj,
  getMyAll,
  getMyPage,
} from '@/api/favoritevehicleserv'

export default {
  state: {
    state_FavoriteVehicle_GetAllResult: null,
    state_FavoriteVehicle_SearchByNameResult: null,
    state_FavoriteVehicle_GetPageResult: null,
    state_FavoriteVehicle_GetDetailResult: null,
    state_FavoriteVehicle_AddObjResult: null,
    state_FavoriteVehicle_ModifyObjResult: null,
    state_FavoriteVehicle_DeleteObjResult: null,
    state_FavoriteVehicle_GetMyAllResult: null,
    state_FavoriteVehicle_GetMyPageResult: null,
  },
  mutations: {
    SET_FAVORITEVEHICLE_GETALL_RESULT: (state, rst) => {
      state.state_FavoriteVehicle_GetAllResult = rst;
    },
    SET_FAVORITEVEHICLE_SEARCHBYNAME_RESULT: (state, rst) => {
      state.state_FavoriteVehicle_SearchByNameResult = rst;
    },
    SET_FAVORITEVEHICLE_GETPAGE_RESULT: (state, rst) => {
      state.state_FavoriteVehicle_GetPageResult = rst;
    },
    SET_FAVORITEVEHICLE_GETDETAIL_RESULT: (state, rst) => {
      state.state_FavoriteVehicle_GetDetailResult = rst;
    },
    SET_FAVORITEVEHICLE_ADDOBJ_RESULT: (state, rst) => {
      state.state_FavoriteVehicle_AddObjResult = rst;
    },
    SET_FAVORITEVEHICLE_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_FavoriteVehicle_ModifyObjResult = rst;
    },
    SET_FAVORITEVEHICLE_DELETEOBJ_RESULT: (state, rst) => {
      state.state_FavoriteVehicle_DeleteObjResult = rst;
    },
    SET_FAVORITEVEHICLE_GETMYALL_RESULT: (state, rst) => {
      state.state_FavoriteVehicle_GetMyAllResult = rst;
    },
    SET_FAVORITEVEHICLE_GETMYPAGE_RESULT: (state, rst) => {
      state.state_FavoriteVehicle_GetMyPageResult = rst;
    },
  },
  actions: {
    FavoriteVehicleServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_FAVORITEVEHICLE_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_FAVORITEVEHICLE_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    FavoriteVehicleServ_SearchByName({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        searchByName(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_FAVORITEVEHICLE_SEARCHBYNAME_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_FAVORITEVEHICLE_SEARCHBYNAME_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    FavoriteVehicleServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_FAVORITEVEHICLE_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_FAVORITEVEHICLE_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    FavoriteVehicleServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_FAVORITEVEHICLE_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_FAVORITEVEHICLE_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    FavoriteVehicleServ_AddObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_FAVORITEVEHICLE_ADDOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_FAVORITEVEHICLE_ADDOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    FavoriteVehicleServ_ModifyObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_FAVORITEVEHICLE_MODIFYOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_FAVORITEVEHICLE_MODIFYOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    FavoriteVehicleServ_DeleteObj({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_FAVORITEVEHICLE_DELETEOBJ_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_FAVORITEVEHICLE_DELETEOBJ_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    FavoriteVehicleServ_GetMyAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_FAVORITEVEHICLE_GETMYALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_FAVORITEVEHICLE_GETMYALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    FavoriteVehicleServ_GetMyPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getMyPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_FAVORITEVEHICLE_GETMYPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_FAVORITEVEHICLE_GETMYPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_FavoriteVehicle_GetAllResult: state => {
      return state.state_FavoriteVehicle_GetAllResult;
    },
    get_FavoriteVehicle_SearchByNameResult: state => {
      return state.state_FavoriteVehicle_SearchByNameResult;
    },
    get_FavoriteVehicle_GetPageResult: state => {
      return state.state_FavoriteVehicle_GetPageResult;
    },
    get_FavoriteVehicle_GetDetailResult: state => {
      return state.state_FavoriteVehicle_GetDetailResult;
    },
    get_FavoriteVehicle_AddObjResult: state => {
      return state.state_FavoriteVehicle_AddObjResult;
    },
    get_FavoriteVehicle_ModifyObjResult: state => {
      return state.state_FavoriteVehicle_ModifyObjResult;
    },
    get_FavoriteVehicle_DeleteObjResult: state => {
      return state.state_FavoriteVehicle_DeleteObjResult;
    },
    get_FavoriteVehicle_GetMyAllResult: state => {
      return state.state_FavoriteVehicle_GetMyAllResult;
    },
    get_FavoriteVehicle_GetMyPageResult: state => {
      return state.state_FavoriteVehicle_GetMyPageResult;
    },
  }
}